import classNames from 'classnames';
import type { ReactNode } from 'react';
import styled from 'styled-components';

import { Sparkles } from '#src/atoms/animations/Sparkles/index.tsx';
import { Star } from '#src/atoms/icons/Star.tsx';
import { ConditionalWrapper } from '#src/atoms/layout/ConditionalWrapper/index.tsx';
import { Horizontal } from '#src/atoms/layout/flex/index.tsx';
import { range } from '#src/lib/arrays.ts';
import type { Unit } from '#src/lib/style.ts';

const Root = styled(Horizontal).attrs({ center: true })`
  display: inline-flex;
  gap: 1px;
  padding: var(--half-unit) var(--half-unit);
  border-radius: var(--quadruple-unit);
  border: 1px solid var(--c-nd-500);
  background:
    linear-gradient(to bottom right, transparent 50%, var(--c-nd-150) 51%),
    var(--c-nd-50-opaque);

  &.tierZero {
    color: var(--c-yellow-400);
    border-color: var(--c-yellow-200);
  }
`;

type Props = {
  count: number;
  size?: Unit;
  sparkles?: boolean;
  children?: ReactNode;
};

export const Stars = ({
  count,
  size = 1,
  sparkles = false,
  children,
}: Props) => {
  return (
    <ConditionalWrapper wrap={sparkles} Wrapper={Sparkles}>
      <Root className={classNames({ tierZero: sparkles }, 'text-center')}>
        {range(count).map(i => (
          <Star key={i} size={size} role="img" />
        ))}
        {children}
      </Root>
    </ConditionalWrapper>
  );
};
